import { defineMessages } from 'react-intl';

export default defineMessages({
    ok: {
        id: 'app.components.UploadValidationConfirmation.ok',
        defaultMessage: 'Ok'
    }
});



// WEBPACK FOOTER //
// ./app/components/confirmation-message/messages.js